import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { HelperFunctions } from 'src/app/services/helper-functions';
import { SportServicesService } from 'src/app/services/sport-service/sport-services.service';
import { UserManagerService } from 'src/app/services/user-manager/user-manager.service';
import { SelectdateComponent } from '../selectdate/selectdate.component';
import { SettlementAction } from '@model/action-bar-item.model';
declare var $: any;

@Component({
  selector: 'app-settlement',
  templateUrl: './settlement.component.html',
  styleUrls: ['./settlement.component.scss']
})
export class SettlementComponent implements OnInit {
  @Input() id: String;
  filter = [];
  selectedAction = { label: '', key: '', value: false };

  selectedMarkets = [];
  list: any = [];
  actions: SettlementAction[] = [{
    label: 'cancel_bet', key: 'cancel', value: false, url: "cancel_bet",
    canPerform: true
  },
  {
    label: 'rollback_cancel_bet', key: 'cancel', value: true, url: "rollback_settlement",
    canPerform: true
  },
  {
    label: 'rollback_settlement', key: 'settlement', value: false, url: "rollback_settlement",
    canPerform: true
  },]
  all = false
  createdSuccessfully: any;
  from_opened: any;
  to_start: any;
  selectAll() {
    // this.all = true;
    for (let item of this.list) {
      item.value = this.all;
    }
  }
  searchdata: any = {
    sportId: '',
    startDate: new Date(new Date().setHours(0, 0, 0)).getTime(),
    endDate: '',
    type: this.filter[0]
  };
  start_date: Date;
  end_date: Date;
  constructor(private helperFunction: HelperFunctions,
    private messageServrice: MessageService,
    private translate: TranslateService,
    public dialog: MatDialog,
    public sport: SportServicesService,
    public userService: UserManagerService) { }

  ngOnInit() {
    this.sport.loadMarketsForSettlement({}, this.id).then(res_ => {
      this.filter = Object.keys(this.sport.settlementMarkets)
      this.list = this.sport.settlementMarkets[this.filter[0]];
      this.searchdata.type = this.filter[0];
    })

  }
  showModal(action) {
    this.getMarkets()
    const translateObject = { name: this.translate.instant('markets') };
    if (!this.selectedMarkets.length) {
      this.messageServrice.add({ severity: 'error', summary: this.translate.instant('no_item_seleted', translateObject), detail: '' });
      return;
    }

    if (action.label != "rollback_settlement") {
      this.selectedAction = action;
      this.openDialog();
      return;
    }
    else {
      this.performAction(action)
    }
  }
  searchData(searchdata) {
    this.list = this.sport.settlementMarkets[searchdata.type]
    for (let item of this.list) {
      if (!item.value) {
        this.all = false;
        return;
      }
      else this.all = true;
    }

  }

  performAction(action) {
    this.selectedMarkets = [];
    this.getMarkets()
    const translateObject = { name: this.translate.instant('markets') };
    if (!this.selectedMarkets.length) {
      this.messageServrice.add({ severity: 'error', summary: this.translate.instant('no_item_seleted', translateObject), detail: '' });
      return;
    }
    if ((!this.start_date || !this.end_date) && (action.label != "rollback_settlement")) {
      this.messageServrice.add({ severity: 'error', summary: this.translate.instant('select_valid_dates'), detail: '' });
      return;
    }
    const message = this.translate.instant(action.label + '_for_selected', translateObject);
    let params: any = {
      actions: {},
      targets: this.selectedMarkets,

    };
    let date = {}
    if (action.label != "rollback_settlement") {
      date = {
        start_date: new Date(this.start_date).getTime(),
        end_date: new Date(this.end_date).getTime()
      }
    }
    // this.selectedMarkets.forEach(event => {
    //   params.targets.push(event.id);
    // });
    params.actions[`${action.key}` + '|' + this.id] = date
    // params.actions = {`${action.key}`} : }action.value;

    this.helperFunction.presentAlert('warning', this.translate.instant('confirm') + '?', '', message).then(result => {
      if (result.value) {
        this.helperFunction.presentAlertLoader();
        this.userService.eventSettlementDoActions(params, action.url).then(data => {
          this.helperFunction.close();
          if (data && data.hasOwnProperty('erc') && data.erc === '1') {
            // tslint:disable-next-line: max-line-length
            this.helperFunction.presentAlert('success', this.translate.instant('success'), this.translate.instant('operation_successfull'), null, null);
            this.clear();
            // this.selectedMarkets.markets = [];
            // this.getEventMarkets();
          } else {
            // tslint:disable-next-line: max-line-length
            this.helperFunction.presentAlert('error', this.translate.instant('failed'), data.msg ? data.msg : this.translate.instant('something_went_wrong'), null, null);
          }
        }).catch(err => {
          this.helperFunction.close();
          // console.log(err);
          this.helperFunction.presentAlert('error', this.translate.instant('failed'), this.translate.instant('server_error'), null, null);
        });
      }
    });
  }
  clear() {
    this.selectedMarkets = [];
    for (let item of this.list) {
      item.value = false;
    }
  }
  getMarkets() {
    for (let item of this.list) {
      if (item.value == true)
        this.selectedMarkets.push(item.mid);
    }
  }
  openDialog(): void {
    const dialogRef = this.dialog.open(SelectdateComponent, {
      maxWidth: '80%',
      panelClass: "scrollable",
      disableClose: true,
      data: { created: this.createdSuccessfully, selectedAction: this.selectedAction }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.start_date = result.start_date;
        this.end_date = result.end_date;
        this.from_opened = result.from_opened;
        this.to_start = result.to_start;
        this.performAction(this.selectedAction);
      }
    });
  }
}
